// extracted by mini-css-extract-plugin
export var center = "header-module--center--OnI0E";
export var container = "header-module--container--O5DHA";
export var nav_items = "header-module--nav_items--9J0mU";
export var project_title = "header-module--project_title--DV+p8";
export var project_tools = "header-module--project_tools--jKA6X";
export var reset = "header-module--reset--9HOZV";